import {LocationType, ProjectUserInfoData} from '@/services/ProjectAuthApi/types';

export const userInfoResponse: ProjectUserInfoData = {
  user: {
    id: '1',
    ssoId: '2',
  },
  settings: {
    remindersEnabled: false,
    musicEnabled: false,
    soundsEnabled: false,
  },
  game: {
    location: {
      type: LocationType.Location1,
    },
    isDailyCompleted: false,
  },
  aBTestInfo: null,
  dailyRewards: {
    availableToday: false,
  },
  onboarding: {
    // 1 - главный онбординг
    // 2 - онбординг в шифре
    // 3 - тултип о шифре
    // 4 - тултип о настройках
    // 5 - тултип о скором пересчете лиг
    // 6 - тултип о таймере до пересчета лиг
    projectOnboardingStatus: '-1 -1 -1 -1 -1 -1',
    onboardingGiftIsAvailable: true,
  },
};
